import githubLogo from '../assets/github.png'
import linkedInLogo from '../assets/linkedin.png'
import googleDevLogo from '../assets/gdev.png'
import leetCodeLogo from '../assets/leetcode.png'


const ConnectWith = () => {
    return ( 
        <div className="connections">
            <h2>CONNECT</h2>
            <div className="container">
                <div className="connection connection1"><a href="https://github.com/MyLordHitsHard/" target="_blank" rel="noreferrer"><img src={githubLogo} alt="Logo of Github" /></a><span>GitHub</span></div>
                <div className="connection connection2"><a href="https://www.linkedin.com/in/himanshu-dutt-702b72200/" target="_blank" rel="noreferrer"><img src={linkedInLogo} alt="Logo of Linkedin" /></a><span>LinkedIn</span></div>
                <div className="connection connection3"><a href="https://developers.google.com/profile/u/HimanshuDutt/" target="_blank" rel="noreferrer"><img src={googleDevLogo} alt="Logo of Google Developer" /></a><span>Google Dev</span></div>
                <div className="connection connection4"><a href="https://leetcode.com/feel_lord/" target="_blank" rel="noreferrer"><img src={leetCodeLogo} alt="Logo of Leetcode" /></a><span>LeetCode</span></div>
            </div>
        </div>
     );
}
 
export default ConnectWith;